let googleMapsPromise = null
const API_KEY = process.env.GOOGLE_MAPS_API_KEY
const MAP_ID = process.env.GOOGLE_MAPS_MAP_ID

export function mapID() {
  return MAP_ID
}

export function loadGoogleMaps() {
  if (googleMapsPromise) return googleMapsPromise

  googleMapsPromise = new Promise((resolve, reject) => {
    if (window.google?.maps?.Map) {
      resolve(window.google)
      return
    }

    if (window.__googleMapsLoading) {
      const check = setInterval(() => {
        if (window.google?.maps?.Map) {
          clearInterval(check)
          resolve(window.google)
        }
      }, 50)

      return
    }

    window.__googleMapsLoading = true

    const script = document.createElement('script')

    script.src =
      `https://maps.googleapis.com/maps/api/js?key=${API_KEY}&loading=async&libraries=places,marker`

    script.async = true

    script.onload = () => {
      const checkReady = setInterval(() => {
        if (window.google?.maps?.Map) {
          clearInterval(checkReady)
          resolve(window.google)
        }
      }, 50)
    }

    script.onerror = () => {
      reject(new Error('Google Maps script failed to load'))
    }

    document.head.appendChild(script)
  })

  return googleMapsPromise
}
